import React from 'react'
import { connect } from 'react-redux'
import {
  showPopupDialog,
  showPopupSuccessSnackbar,
  showPopupErrorSnackbar,
} from 'support/popup_dialogs'
import ErrorSubmitModal from './components/dialogs/ErrorSubmitContainer'

import { getIdeaTemplatelist, cloneIdeaTemplate } from 'services/innovate/templates'
import View from './View'



const mapStateToProps = state => ({
  myEmail: state.data.user.userEmail,
  listIdeaTemplateLoading: state.data.templates.listIdeaTemplateLoading,
  listIdeaTemplate:state.data.templates.listIdeaTemplate,
})

const mapDispatchToProps = dispatch => {
  return {
    getIdeaTemplatelistFn: ()=>{
      dispatch(getIdeaTemplatelist())
    },
    getCloneIdeaTemplateFn: (cloneIdeaParams, onSuccessCallback) => {

      const onSuccess = (data) => {
        const message = 'Template clone has been completed.';
        
        dispatch(getIdeaTemplatelist())
        showPopupSuccessSnackbar(message, dispatch);
        
        // ✅ trigger component callback
        onSuccessCallback?.(data);
      };
    
      const onFailure = ({ data }) => {
        const messageTag =
          data && data.error
            ? `${data.error.desc}`
            : 'BACKEND_ERRORS.UNEXPECTED';
    
        showPopupDialog(
          <ErrorSubmitModal description={messageTag} />,
          dispatch
        );
      };
    
      dispatch(cloneIdeaTemplate(cloneIdeaParams, onSuccess, onFailure));
    }

  }
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(View)